/**
 * `noopLoggerFactory` — implementação default que não faz nada.
 *
 * Usado antes do `setGlobalLoggerFactory(...)` ser chamado pelo composition root
 * (em produção: `@planuze/observability` + pino; em testes: factory mock).
 *
 * Como NOOP é stateless, é singleton: `create()` sempre retorna a mesma
 * instância e `child()` também — zero alocação por chamada.
 */
import type { Logger, LoggerFactory } from './types.js';

const NOOP = (): void => undefined;

const noopInstance: Logger = {
  debug: NOOP,
  info: NOOP,
  warn: NOOP,
  error: NOOP,
  fatal: NOOP,
  child(): Logger {
    return noopInstance;
  },
};

export const noopLoggerFactory: LoggerFactory = {
  create() {
    return noopInstance;
  },
};
